import React from 'react';
import {
    Grid,
    Typography,
    Hidden,
    Avatar,
} from '@material-ui/core';
import useStyles from './styles';
import clsx from 'clsx';
import { Coin } from '../component'

const DefaultLayout = ({ children, ...props }) => {
    const {
        title,
        type = '',
        description = '',
        progressBar,
        coin,
        image,
        profile,
        avatar
    } = props;
    const classes = useStyles(props);

    return (
        <Grid container className={(clsx(classes.defaultLayout))}>
            <Grid
                container
                item
                xs={12}
                alignItems="center"
                justify="center"
                className={(clsx(
                    classes.defaultLayoutHeader,
                ))}>
                <Grid item md={7} sm={8} xs={10} container justify="center" direction="column">
                    <Typography
                        classes={{ body1: classes.body1 }}
                        align="center"
                        className={(
                            clsx(
                                classes.title,
                                //type === 'Survey' && classes.titleBlue,
                                type === 'Challenge' && classes.titleBlue,
                                type === 'Reward' && classes.textColorReward,
                                profile === 'true' && classes.titleProfile
                            ))}
                    >
                        {title}
                    </Typography>
                    {description !== '' &&
                        <Typography
                            classes={{ body1: classes.body1 }}
                            align="center"
                            className={(clsx(
                                classes.description,
                                //type === 'Survey' && classes.titleBlue,
                                type === 'Challenge' && classes.titleBlue,
                                type === 'Reward' && classes.textColorReward,
                            ))}
                        >
                            {description}
                        </Typography>
                    }
                    {progressBar && description === '' &&
                        <>
                            {progressBar}
                        </>
                    }
                    {profile === 'true' &&
                        <Grid container justify="center" direction="column" alignItems="center">
                            <Avatar classes={{ root: classes.rootAvatar }} src={avatar}></Avatar>
                        </Grid>
                    }
                    {coin &&
                        <div className={(clsx(classes.coin))}>
                            <Hidden smDown>
                                <Coin size="big" coin={coin} />
                            </Hidden>
                            <Hidden mdUp>
                                <Coin size="medium" coin={coin} />
                            </Hidden>
                        </div>}
                </Grid>
            </Grid>
            <Grid
                container
                xs={12}
                item
                alignItems="center"
                justify="center"
            >
                <Grid container alignItems="center" justify="center">
                    {children}
                </Grid>
            </Grid>
        </Grid>
    )
}

export default DefaultLayout;